import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
    standalone: false
})
export class ConfirmModalComponent{
  @Input() type: string = 'success'; //error - success
  @Input() image: string = '/assets/certificados/icons/info_modal.svg';
  @Input() title: string;
  @Input() description: string;
  @Output() closeModal = new EventEmitter<boolean>(false);
  closeIcon: string = '/assets/certificados/icons/close_modal.svg';

  close() {
    this.closeModal.emit(true);
  }
}
